import React, { useState } from 'react';
import axios from 'axios';
import { Link, useNavigate } from 'react-router-dom';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import API_URL from './api/config';

function ForgotPassword() {
  const [values, setValues] = useState({ email: '' });
  const [loading, setLoading] = useState(false); // 🔸 New loading state
  const navigate = useNavigate();
  axios.defaults.withCredentials = true;

  const handleForgotPassword = (e) => {
    e.preventDefault();
    setLoading(true); // 🔸 Disable the button

    axios.post(`${API_URL}/forgot-password-api`, {
      email: values.email
    })
      .then(res => {
        if (res.data.Status === "Success") {
          toast.success("Password reset link sent!", { position: "top-right", autoClose: 3000 });
          navigate(res.data.redirect);
        } else {
          toast.error(res.data.Message, { position: "top-right", autoClose: 3000 });
        }
      })
      .catch(() => {
        toast.error("An error occurred. Please try again.", { position: "top-right", autoClose: 3000 });
      })
      .finally(() => {
        setLoading(false); // 🔸 Re-enable after response
      });
  };

  return (
    <div className="bg_med_green text-white min-vh-100 d-flex align-items-center justify-content-center">
      <ToastContainer />
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-md-6 col-lg-6">
            <div className="bg-med-green text-white p-4 rounded">
              <div className="card-body text-center">
                <div className="py-3">
                  <img src="img/logo_1.png" alt="" height="48" />
                </div>

                <form onSubmit={handleForgotPassword}>
                  <div className="row g-3">
                    <div className="col-12">
                      <label>Email</label>
                      <input
                        type="email"
                        className="form-control"
                        onChange={e => setValues({ ...values, email: e.target.value })}
                        required
                      />
                    </div>

                    <div className="col-12">
                      <button
                        type="submit"
                        className="btn btn-primary w-100"
                        disabled={loading} // 🔸 Disable while loading
                      >
                        {loading ? "Processing..." : "Reset Password"} {/* 🔸 Show progress */}
                      </button>
                    </div>
                  </div>
                </form>

                <p className="text-center text-white" style={{ marginTop: '10%' }}>
                  Already have an account?
                  <Link to="/" style={{ color: '#184A2C', textDecoration: 'none' }}> Login</Link>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ForgotPassword;
